// extracted by mini-css-extract-plugin
export default {"tab":"src-Tab-module__tab--QXfRO","focus-visible":"src-Tab-module__focus-visible--j_bRD","badge":"src-Tab-module__badge--s7SIF","selected":"src-Tab-module__selected--nFvgo"};